import { get } from 'lodash'

export default {
  methods: {
    async createThread() {
      const response = await this.$client.execute({
        operationId: 'Ai_createThread',
      })
      try {
        const data = JSON.parse(response.data)
        return get(data, 'id')
      } catch (e) {
        return null
      }
    },
  },
}
